export interface SearchTableConfiguration {
    theme: 'basic' | 'quotes' | 'cybersecurity'
    columns: SearchTableColumnConfiguration[]
}

export enum SearchTableTheme {//eslint-disable-line @stencil-community/ban-exported-const-enums
    Basic = 'basic',
    Quotes = 'quotes',
    Cybersecurity = 'cybersecurity',
}

export interface SearchTableColumnConfiguration {
    fieldName: string
    fileFieldName: string
    fieldType?: string
    status?: boolean
    width?: string
    url?: string
    icon?: string
    text?: string
    paddingLeft?: string
    title: string
    sortable?: boolean
    sortOrder?: SortOrder
    left?: string
    headerNotBold?: string
    actions?: SearchTableActionColumnConfiguration[]
    highlightResult?: boolean,
    dateColumnWithHours?: boolean,
    quotePdfConfiguration?: QuotePdfConfiguration,
    fileName?: string
}

export interface SearchTableActionColumnConfiguration {
    buttonText?: string
    modal?: boolean
    modalTitle?: string
    modalDescription?: string
    modalConfirmUrl?: string
    actionType?: SearchTableActionType,
    fallbackUrl?: string
    idFieldName?: string
}

export interface SortableHeader{
    sortOrder: SortOrder,
    fieldName: string
}

export interface TableDeletedActionClicked{
    id?: string,
    url?: string
}

export enum SearchTableActionType {//eslint-disable-line @stencil-community/ban-exported-const-enums
    Edit = 'edit',
    Delete = 'delete',
};

export enum SortOrder{//eslint-disable-line @stencil-community/ban-exported-const-enums
    Descending = 'desc',
    Ascending = 'asc',
    None = 'none'
}

export interface QuotePdfConfiguration{
    token: string,
    url: string,
    apiKey: string,
    purchaserId: string,
    countryCode: string,
    language: string
}
